module.exports = __webpack_public_path__ + "img/chocks-no.2cc2345d.svg";